module.exports = __webpack_public_path__ + "static/media/025.ad266a92.jpg";